import S from 's-js';
import { IAjax } from 'lib/Ajax';
import { ValidationWatcher } from 'lib/validationWatcher';
import { TZUtils } from 'lib/tzutils';

import { PCCache } from 'data/PCCache';

import { DispatchEvent, DispatchEventOptions } from 'data/models/DispatchEvent';

import { LocalizationContext } from 'common/models/LocalizationContext';

import { BillExportSettings, BillExportSettingsParams } from 'portcall/billexportsettings/model';

export interface AddDispatchEventParams {
    url : () => string;
    canManageBills : () => boolean;
    onAddDispatchEvent : (event : DispatchEvent) => void;
    onCancel : () => void;
}

export function AddDispatchEvent(
    ajax : IAjax,
    data  : PCCache,
    tzutils : TZUtils,
    localization : LocalizationContext,
    billExportSettingsModel : (params : BillExportSettingsParams) => BillExportSettings,
    { url, canManageBills, onAddDispatchEvent, onCancel } : AddDispatchEventParams
) {
    const dispatchEvent = new DispatchEvent({
            Id: 0,
            Start: tzutils.now().toJSON()
        }),
        billExportSettings = billExportSettingsModel({
            DraftModel: dispatchEvent,
            LastExportDate: () => null,
            ApproveAndRecalculate: null
        }),
        client = ajax.Url<DispatchEvent, DispatchEventOptions>(url),
        validation = ValidationWatcher(client);

    return {
        Model: dispatchEvent,
        BillExportSettings: billExportSettings,
        CanManageBills: canManageBills,
        Validation: validation,
        AddDispatchEvent,
        Cancel: onCancel,
        Localization: localization
    };

    function AddDispatchEvent() {
        const req = client.Post(dispatchEvent);
        req.then(json => S.freeze(() => {
            const event = data.DispatchEvents.update1(req.Date, json);
            onAddDispatchEvent(event);
        }));
    }
}
export type AddDispatchEvent = ReturnType<typeof AddDispatchEvent>;


// WEBPACK FOOTER //
// ./apps/pilots/dispatchdashboard/adddispatchevent.ts